module.exports = __webpack_public_path__ + "static/img/200134.c4480c83.png";